import api from '@services/api';
import { GeneratedReportRequest, GenerateUrlParams, IGeneratedReport } from '../models/generatedReport';

/**
 * <p>
 * API endpoints that cover all generated report related CRUD calls
 */
export const generatedReportApi = api.injectEndpoints({
  endpoints: (builder) => ({
    exportProject: builder.mutation<void, GeneratedReportRequest>({
      query: (project: GeneratedReportRequest) => ({
        url: encodeURI(`/report/project/export`),
        method: 'POST',
        body: project,
      }),
      invalidatesTags: ['ExportProject'],
    }),
    generateSignedUrl: builder.query<IGeneratedReport, GenerateUrlParams>({
      query: (params) => ({
        url: encodeURI(`/report/project/generateSignedLink?projectCode=${params.projectCode}`),
        method: 'GET',
      }),
    }),
    syncPlanningReport: builder.mutation<void, string>({
      query: (project: string) => ({
        url: encodeURI(`/report/planning-report/request?project=${project}`),
        method: 'POST',
      }),
      invalidatesTags: ['ExportProject'],
    }),
  }),
});

export const { useExportProjectMutation, useGenerateSignedUrlQuery, useSyncPlanningReportMutation } =
  generatedReportApi;
